import { Box } from '@zillow/constellation-10';
import { Col, Row } from '@zg-rentals/zrs-comet';
import Bone from '../../../Bone';
import { StyledListboxOptionForSkeleton } from './StyledComponents';

const Skeleton = () => {
  return (
    <StyledListboxOptionForSkeleton>
      <Box css={{ padding: 'default' }}>
        <Row hidden={[]}>
          <Col xs={5}>
            <Bone dark={true} />
          </Col>
        </Row>

        <Row hidden={[]} paddingY="xs">
          <Col>
            <Bone dark={true} />
          </Col>
        </Row>
      </Box>
    </StyledListboxOptionForSkeleton>
  );
};

export default Skeleton;
